import { Info, Trash2 } from 'lucide-react';

import { PageHeader } from '@@/PageHeader';
import { Button } from '@@/buttons';
import { Widget } from '@@/Widget';
import { InlineLoader } from '@@/InlineLoader';

import { TagsDatatable } from './TagsDatatable/TagsDatatable';
import { useRepositoryEditViewData } from './hooks/useRepositoryEditViewData';
import { RepositoryDeletionProgressModal } from './RepositoryDeletionProgressModal';

export function RepositoryEditView() {
  const {
    // Data
    breadcrumbs,
    repositoryName,
    tagNames,
    datatableTags,
    actionInProgress,
    canDelete,
    canUpdate,
    repositoryDeletionState,
    isTagsLoading,

    // Handlers
    handleRemoveTags,
    handleRemoveRepository,
    refetchTags,
  } = useRepositoryEditViewData();

  return (
    <>
      <PageHeader
        title="Repository"
        breadcrumbs={breadcrumbs}
        reload
        onReload={async () => {
          await refetchTags();
        }}
      />
      <div className="row">
        <div className="col-sm-12">
          <Widget>
            <Widget.Title title="Repository information" icon={Info} />
            <Widget.Body className="no-padding">
              <table className="table">
                <tbody>
                  <tr>
                    <td>Repository</td>
                    <td>{repositoryName}</td>
                    <td className="text-right">
                      {canDelete && (
                        <Button
                          size="xsmall"
                          color="dangerlight"
                          icon={Trash2}
                          onClick={handleRemoveRepository}
                          data-cy="delete-repository-btn"
                          disabled={actionInProgress}
                        >
                          Delete this repository
                        </Button>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Tags count</td>
                    <td>
                      {isTagsLoading ? (
                        <InlineLoader>Loading tags...</InlineLoader>
                      ) : (
                        tagNames.length
                      )}
                    </td>
                    <td />
                  </tr>
                </tbody>
              </table>
            </Widget.Body>
          </Widget>
        </div>
      </div>

      {datatableTags && datatableTags.length > 0 && (
        <TagsDatatable
          dataset={datatableTags}
          onRemove={handleRemoveTags}
          canDelete={canDelete}
          canUpdate={canUpdate}
          actionsDisabled={actionInProgress}
        />
      )}

      <RepositoryDeletionProgressModal
        isOpen={repositoryDeletionState?.status === 'PROCESSING'}
        progressPercentage={
          repositoryDeletionState?.totalCount
            ? Math.round(
                (repositoryDeletionState.completedCount /
                  repositoryDeletionState.totalCount) *
                  100
              )
            : 0
        }
        elapsedTime={repositoryDeletionState?.elapsedTime || 0}
      />
    </>
  );
}
